import React from 'react';
import {Image} from '@jobseeker/lotus/components/Image';
import {Box, Typography, Button} from '@mui/material';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import useInterceptor from '@jobseeker/common-core/hooks/useInterceptor';
import {useRouter} from 'next/router';
import {useEffect} from 'react';
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const Description = () => {
  const theme = useWrappedTheme();
  const interceptor: any = useInterceptor();
  const router = useRouter();

  useEffect(() => {
    // Check for query parameter "scrollTo" in the URL
    if (router.query.scrollTo === 'earlyApplicant') {
      // Scroll to the element with the ID "early-applicant"
      const targetElement = document.getElementById('early-applicant');
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    } else if (router.query.scrollTo === 'resumeBuilder') {
      // Scroll to the element with the ID "resume-builder"
      const targetElement = document.getElementById('resume-builder');
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }
    }
  }, [router.query.scrollTo]);

  const {
    proMembership: {plansArray},
  } = interceptor;

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '720px',
        height: {
          sm: 1100,
          md: 740,
          xxs: 1100,
          '@media (max-width:1024px) and (min-width:1024px)': {
            height: 1200,
          },
        },
        backgroundColor: 'border.lightGrey',
        padding: {xs: '60px 0', md: '100px 0'},
        textAlign: 'center',
        backgroundImage: `url('https://job-static.iimjobs.com/V2/static/media/heart.00b4706e.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '13px 25px 15px 20px',
          margin: 'auto auto 17px',
          backgroundColor: '#13355c',
          borderRadius: 2,
          color: '#feae02',
          fontWeight: 'bold',
          fontSize: theme.typography.pxToRem(16),
          width: 'max-content',
        }}
      >
        <Image
          src={
            isAppIimjobs
              ? `${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/crownYellow@2x.png`
              : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAAAiCAMAAAAnKQpfAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABIUExURUdwTP//4f+/Kf/FLv+/KP/CLf+/KP+/Kf/AKf/KNv/AKf+/KP+/KP/AKv+/Kf+/Kf+/KP+/KP/BK/+/Kf+/KP+/Kf+/Kf++KAX0DW0AAAAXdFJOUwABqQ+/Gfv0PARS6uBEebRp8CnXyJSBRhWSlQAAAZRJREFUOMvFVduygyAMVJSLoIKg3f//0xOo9UCFzvSpOx2nQBI3mwS77tfgzBjGv3KZ+AbC9p2XBePcwrYt+kHrMma/Yei6AVtfcs7snATEIz+fhJhez/9IDwFI91xowDIBl8cccUzTgTHfcxDMAjot9mi/YM4NvIGUMD7fm7FEzz0tZOTfmfS8+Omons59Bpj03NIqQFGOokz6wEG/UhxBKiiEtFoxOx2wLXlYCe8h85cvG4J2M9YnFRupkIKZgCyWiIqVSZdMSLOXoPrYwVaBkV8WkjTw8orDR4iVYT/yNLkQXBkYFwmp8dRAUxwVyTo6UtGm7ApGXDmjIoed2s6c+S2GGnAPVFTLKXf21kpUJ2KibOQ9r5cAwzrThrAUpE91KrstPLd67snjUoT+DIp2+lfYEq+X91OjrdkpdtHptzTfprJ6XolUY1KTojlzdxlyKepohaQeHJuYG+Q5PqIuUy+gmgAaCZdz2N0nsIYA33Ly5+zdsccRrkOdV0PthtRTA7p5b7JP4rGGkzayCaN/8h36A5tNHYcT17qLAAAAAElFTkSuQmCC'
          }
          alt="Crown Premium Icon"
          width={24}
          height={15}
          style={{marginRight: 6, padding: 1}}
        />
        GO PREMIUM
      </Box>

      <Box
        sx={{
          position: 'relative',
          maxWidth: {xs: '100%', md: 680},
          margin: '0 auto',
          marginBottom: '35px',
        }}
      >
        <Typography
          variant="h3"
          sx={{
            fontSize: {
              xs: theme.typography.pxToRem(32),
              md: theme.typography.pxToRem(45),
              sm: theme.typography.pxToRem(45),
            },
            fontWeight: 'bold',
            position: 'relative',
            textAlign: 'center',
            padding: {xs: '0 15px', md: '0'},
          }}
        >
          <Image
            src={
              isAppIimjobs
                ? `${process.env.NEXT_PUBLIC_STATIC_IIMJOBS}/static/images/design-element.webp`
                : 'data:image/webp;base64,UklGRjICAABXRUJQVlA4WAoAAAAQAAAALwAALwAAQUxQSMQAAAABgFtt2/LkSXDooHLvvPUFkgFgBfcBoHQYAAZwGUKHiEyAu9xF/MG7iJgA/Z8CH7+XoFn11o5VwcI99DnpFDgLOPUCDDppF4gUObW8ADNO2gAuy50qLoE1J80Bz82Z5LYoCuw4aQig2ylwAZw4aQDu5wuctLdZJe+gcpjXmpWcTr8ullrV3UEs5HRM4nalTziewPVw0EVly28knnW6SF3nCbwulbooOHpNYizkIlXtJnDgI4VjcFvjpLLlt0mZt+a5/QkDVlA4IEgBAADQCgCdASowADAAPm0ykkckIyGhJzgNsIANiWwNvAV+pgn1XT4+m8Oa4TQDzAfrNut3WAegB5Z/sPfuN6OeYAfQBT/vA/+/9yDkhKEp90HT467E9hPUu/luxe8Dg/hAAAD+/gbUN/gp/ZLBGC1HnT9gG1rLgghnTTU3ZLn8XH2hH/HrfxO1HDx24sX1ghtcQu2smBU3tA4gYyXOAR98F98zaCjuG3P9EQ5SmrHh4IRqLgkdTvjOZ9bY0OeP/Jd9J+Tj3f5nMST++4v7HStUGAXjtRFUH2XTIjFqu4h5vE+Yu5PGzhC+AufLejYN85Q6ylJnAlELQdfgcgSHQ14JrnRst8+hFvrF9jB0Bec9VeBE+xn2LPJar4zmbZEusF6UwAOcmDp/XbcT1vhuE/BxllgIKhmnaAiqG3JLGNJ//vzJWOg5uECUdAAA'
            }
            alt="Crown Icon"
            width={25}
            height={25}
            style={{
              position: 'absolute',
              marginLeft: '-11px',
              marginTop: '-13px',
            }}
          />
          Advance your career with us
        </Typography>
        <Typography
          sx={{
            marginTop: 1.1,
            fontWeight: 200,
            textAlign: 'center',
            color: '#000',
          }}
          fontSize={{
            md: theme.typography.pxToRem(22),
            xs: theme.typography.pxToRem(18),
          }}
        >
          Get access to exclusive, customised resources
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          flexWrap: 'wrap',
          marginTop: {md: 7.5},
          marginBottom: {md: 16.5},
        }}
      >
        {plansArray.map((plan: any, index: number) => (
          <Box
            key={index}
            sx={{
              width: {
                xs: '100%',
                sm: 600,
                md: 500,
                '@media (max-width:1024px)': {
                  width: 800,
                },
              },
              paddingX: '20px',
              paddingY: '30px',
              marginLeft: {md: '30px'},
              marginBottom: {xs: '15px'},
              border: '1px solid #f2f2f2',
              borderRadius: 6,
              boxShadow: '0 6px 34px rgba(0, 0, 0, 0.07)',
              backgroundColor: '#fff',
              display: 'flex',
              alignItems: 'center',
              height: {xs: 180},
              backgroundSize: 'cover',
              backgroundImage:
                'url(data:image/png;base64,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)',
            }}
          >
            <Box
              sx={{
                marginRight: '22px',
                marginLeft: '23px',
                // flexShrink: 0,
                // height: {xxs: 50, xs: 50},
              }}
            >
              <Image src={plan.srcImg} alt={plan.name} width={70} height={70} />
            </Box>
            <Box sx={{textAlign: 'left'}}>
              <Typography
                sx={{
                  fontWeight: 800,
                  fontSize: {
                    md: theme.typography.pxToRem(20),
                    xs: theme.typography.pxToRem(18),
                  },
                  marginTop: {xs: 4.2, md: 3.4},
                  color: '#07274a',
                  marginBottom: 1,
                }}
              >
                {plan.name}
              </Typography>
              {plan.description.map((point: string, i: number) => (
                <Box
                  key={i}
                  sx={{
                    display: 'flex',
                  }}
                >
                  <Box
                    sx={{
                      width: '5px',
                      height: '5px',
                      backgroundColor: 'border.deepNavy',
                      borderRadius: '50%',
                      margin: '5px 8px 0 0',
                      justifyContent: 'start',
                    }}
                  ></Box>
                  <Typography
                    sx={{
                      fontSize: {
                        md: theme.typography.pxToRem(14),
                        xs: theme.typography.pxToRem(13),
                      },
                      fontWeight: 300,
                      color: 'border.deepNavy',
                      justifyContent: 'start',
                    }}
                  >
                    {point}
                  </Typography>
                </Box>
              ))}
              <Typography
                variant="body1"
                sx={{
                  fontSize: {
                    md: theme.typography.pxToRem(16),
                    xs: theme.typography.pxToRem(12),
                  },
                  marginTop: {xs: 0, md: '9px'},
                  display: 'flex',
                }}
              >
                <Typography sx={{fontWeight: 'bolder', marginRight: 0.58}}>
                  Rs. {plan.price}
                </Typography>
                <Typography> for {plan.frequency}</Typography>
              </Typography>
              <Button
                variant="text"
                sx={{
                  textTransform: 'none',
                  fontSize: theme.typography.pxToRem(13),
                  marginTop: 0.7,
                  marginBottom: 3.2,
                  cursor: 'pointer',
                  padding: '0',
                  '&:hover': {
                    backgroundColor: '#FFFFFF',
                  },
                }}
                onClick={() => {
                  const targetId =
                    plan.name === 'Early Applicant'
                      ? 'early-applicant'
                      : 'resume-builder';
                  document.getElementById(targetId)?.scrollIntoView({
                    behavior: 'smooth',
                  });
                }}
              >
                Read More
              </Button>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default Description;
